module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pers-tab2-3",
      "name": "hres32e-tab2-tab3"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 pull-left"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['20']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.namfathr),
      expression: "detail.namfathr"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:45'),
      expression: "'max:45'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "namfathr",
      "name": "namfathr",
      "maxlength": "45",
      "data-vv-name": "namfathr",
      "data-vv-as": "namfathr",
      "has-error": _vm.errors.has('namfathr')
    },
    domProps: {
      "value": (_vm.detail.namfathr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "namfathr", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('namfathr')),
      expression: "errors.has('namfathr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('namfathr')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codfnatn[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codfnatn),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codfnatn", $$v)
      },
      expression: "detail.codfnatn"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codfrelg[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codfrelg),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codfrelg", $$v)
      },
      expression: "detail.codfrelg"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codfoccu[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codfoccu),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codfoccu", $$v)
      },
      expression: "detail.codfoccu"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.numofidf),
      expression: "detail.numofidf"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:13'),
      expression: "'max:13'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numofidf",
      "name": "numofidf",
      "maxlength": "13",
      "data-vv-name": "numofidf",
      "data-vv-as": "numofidf",
      "has-error": _vm.errors.has('numofidf')
    },
    domProps: {
      "value": (_vm.detail.numofidf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "numofidf", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numofidf')),
      expression: "errors.has('numofidf')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numofidf')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 pull-right"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic2
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['80']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic2),
      expression: "subTopic2"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.nammothr),
      expression: "detail.nammothr"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:45'),
      expression: "'max:45'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "nammothr",
      "name": "nammothr",
      "maxlength": "45",
      "data-vv-name": "nammothr",
      "data-vv-as": "nammothr",
      "has-error": _vm.errors.has('nammothr')
    },
    domProps: {
      "value": (_vm.detail.nammothr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "nammothr", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nammothr')),
      expression: "errors.has('nammothr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('nammothr')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codfnatn[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codmnatn),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codmnatn", $$v)
      },
      expression: "detail.codmnatn"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codfrelg[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codmrelg),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codmrelg", $$v)
      },
      expression: "detail.codmrelg"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codfoccu[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codmoccu),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codmoccu", $$v)
      },
      expression: "detail.codmoccu"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.numofidm),
      expression: "detail.numofidm"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:13'),
      expression: "'max:13'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numofidm",
      "name": "numofidm",
      "maxlength": "13",
      "data-vv-name": "numofidm",
      "data-vv-as": "numofidm",
      "has-error": _vm.errors.has('numofidm')
    },
    domProps: {
      "value": (_vm.detail.numofidm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "numofidm", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numofidm')),
      expression: "errors.has('numofidm')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numofidm')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 pull-left"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic3
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['140']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic3),
      expression: "subTopic3"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.namcont),
      expression: "detail.namcont"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:45'),
      expression: "'max:45'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "namcont",
      "name": "namcont",
      "maxlength": "45",
      "data-vv-name": "namcont",
      "data-vv-as": "namcont",
      "has-error": _vm.errors.has('namcont')
    },
    domProps: {
      "value": (_vm.detail.namcont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "namcont", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('namcont')),
      expression: "errors.has('namcont')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('namcont')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.adrcont1),
      expression: "detail.adrcont1"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:100'),
      expression: "'max:100'"
    }],
    staticClass: "form-control textarea-text",
    attrs: {
      "id": "adrcont1",
      "name": "adrcont1",
      "maxlength": "100",
      "data-vv-name": "adrcont1",
      "data-vv-as": "adrcont1",
      "has-error": _vm.errors.has('adrcont1')
    },
    domProps: {
      "value": (_vm.detail.adrcont1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "adrcont1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('adrcont1')),
      expression: "errors.has('adrcont1')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('adrcont1')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(100)))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.codpost),
      expression: "detail.codpost"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric|max:5'),
      expression: "'numeric|max:5'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "codpost",
      "name": "codpost",
      "maxlength": "5",
      "data-vv-name": "codpost",
      "data-vv-as": "codpost",
      "has-error": _vm.errors.has('codpost')
    },
    domProps: {
      "value": (_vm.detail.codpost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "codpost", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codpost')),
      expression: "errors.has('codpost')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codpost')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['200']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.email),
      expression: "detail.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:50'),
      expression: "'max:50'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "email",
      "maxlength": "50",
      "data-vv-name": "email",
      "data-vv-as": "email",
      "has-error": _vm.errors.has('email')
    },
    domProps: {
      "value": (_vm.detail.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['180']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.numtele),
      expression: "detail.numtele"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:20'),
      expression: "'max:20'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numtele",
      "name": "numtele",
      "maxlength": "20",
      "data-vv-name": "numtele",
      "data-vv-as": "numtele",
      "has-error": _vm.errors.has('numtele')
    },
    domProps: {
      "value": (_vm.detail.numtele)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "numtele", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numtele')),
      expression: "errors.has('numtele')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numtele')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['190']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.numfax),
      expression: "detail.numfax"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:20'),
      expression: "'max:20'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numfax",
      "name": "numfax",
      "maxlength": "20",
      "data-vv-name": "numfax",
      "data-vv-as": "numfax",
      "has-error": _vm.errors.has('numfax')
    },
    domProps: {
      "value": (_vm.detail.numfax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "numfax", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numfax')),
      expression: "errors.has('numfax')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numfax')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC5']['210']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.desrelat),
      expression: "detail.desrelat"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:15'),
      expression: "'max:15'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "desrelat",
      "name": "desrelat",
      "maxlength": "15",
      "data-vv-name": "desrelat",
      "data-vv-as": "desrelat",
      "has-error": _vm.errors.has('desrelat')
    },
    domProps: {
      "value": (_vm.detail.desrelat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "desrelat", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('desrelat')),
      expression: "errors.has('desrelat')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('desrelat')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray pull-left",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.togglePage(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), (_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d2c2929!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres32e/tab2_3.vue
// module id = 3841
// module chunks = 1